import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Gare from "./pages/Gare";
import Commesse from "./pages/Commesse";
import Dipendenti from "./pages/Dipendenti";
import Impostazioni from "./pages/Impostazioni";
import Trasferte from "./pages/Trasferte";
import "@/App.css";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="loading-screen">
        <div className="h-8 w-8 border-2 border-blue-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="gare" element={<Gare />} />
        <Route path="commesse" element={<Commesse />} />
        <Route path="dipendenti" element={<Protected adminOnly><Dipendenti /></Protected>} />
        <Route path="trasferte" element={<Protected adminOnly><Trasferte /></Protected>} />
        <Route path="impostazioni" element={<Protected adminOnly><Impostazioni /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
